import { useTranslation } from "@coworker/locales";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import StyledModalFooter from "@coworker/apprestructured/src/task-management/components/StyledModalFooter/StyledModalFooter";
import styles from "./SafetyAlarmInfoModalContent.module.css";

type Props = {
  visible: boolean;
  onClose: () => void;
};

function SafetyAlarmInfoModalContent({ visible, onClose }: Props) {
  const { t } = useTranslation();
  const sections = [
    {
      title: "safetyAlarmHealthRelatedTitleString",
      text: "safetyAlarmHealthRelatedString",
    },
    {
      title: "safetyAlarmMarketRequirementsTitleString",
      text: "safetyAlarmMarketRequirementsString",
    },
    {
      title: "safetyAlarmReputationTitleString",
      text: "safetyAlarmReputationString",
    },
    {
      title: "safetyAlarmPropertyDamageTitleString",
      text: "safetyAlarmPropertyDamageString",
    },
  ];

  return (
    <FixaModal visible={visible} handleCloseBtn={onClose}>
      <FixaSheets
        header={
          <FixaModalHeader
            title={t("safetyAlarmString")}
            titleId="safety-alarm-modal"
            closeBtnClick={onClose}
          />
        }
        footer={
          <StyledModalFooter>
            <FixaButton
              text={t("okiunderstandString")}
              type="primary"
              onClick={onClose}
            />
          </StyledModalFooter>
        }
        fullSize
        labelledById="safety-alarm-modal"
      >
        <FixaModalBody>
          <div className={styles["body"]}>
            <FixaText textStyle="Heading.S" tagName="h3">
              {t("safetyAlarmRequiresString")}
            </FixaText>
            {sections.map(({ title, text }) => (
              <section className={styles["section"]} key={title}>
                <FixaText textStyle="Heading.S" tagName="h4">
                  {t(title)}
                </FixaText>
                <FixaText textStyle="Body.L">{t(text)}</FixaText>
              </section>
            ))}
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
}

SafetyAlarmInfoModalContent.buttonAriaLabelKey =
  "safetyAlarmLearnMoreString" as const;

export default SafetyAlarmInfoModalContent;
